import { createModel } from '@/store/tools';
const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'eventtouch',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getEventTriggerByPage': T('getEventTriggerByPage'),
            'getEventTouchEnum': T('getEventTouchEnum'),
            'getPeriodTypeEnum': T('getPeriodTypeEnum'),
            'getOwnerEnum': T('getOwnerEnum'),
            'getProvideTypeEnum': T('getProvideTypeEnum'),
            'getTrigEventTypeEnum': T('getTrigEventTypeEnum'),
            'getTriggerTypeEnum': T('getTriggerTypeEnum'),
            'getlistCoupon': T('getlistCoupon'),
            'getCouponDetail': T('getCouponDetail'),
            'getEventTriggerDetail': T('getEventTriggerDetail'),
        },
        actions: {
            'getEventTriggerByPage': A('getEventTriggerByPage'), // 事件触达列表
            'getEventTouchEnum': A('getEventTouchEnum'), // 状态
            'getPeriodTypeEnum': A('getPeriodTypeEnum'), // 周期
            'getOwnerEnum': A('getOwnerEnum'), // 发放对象
            'getProvideTypeEnum': A('getProvideTypeEnum'), // 发放类型
            'getRewardTypeEnum': A('getRewardTypeEnum'), // 奖励类型
            'getTrigEventTypeEnum': A('getTrigEventTypeEnum'), // 触发事件类型
            'getTriggerTypeEnum': A('getTriggerTypeEnum'), // 事件触发类型
            'getlistCoupon': A('getlistCoupon'), // 优惠券列表
            'getCouponDetail': A('getCouponDetail'), // 优惠券详情
            'getEventTriggerDetail': A('getEventTriggerDetail'), // 触发事件详情
        },
        sagas: {
            'getEventTriggerByPage': S('getEventTriggerByPage', '/?cmd=com.xqxc.api.pig.mis.biz.platform.marketing.EventTriggerMisService.getEventTriggerByPage', 'POST'),
            'getEventTouchEnum': S('getEventTouchEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getPeriodTypeEnum': S('getPeriodTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getOwnerEnum': S('getOwnerEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getProvideTypeEnum': S('getProvideTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getRewardTypeEnum': S('getRewardTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getTrigEventTypeEnum': S('getTrigEventTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getTriggerTypeEnum': S('getTriggerTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getlistCoupon': S('getlistCoupon', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCouponForEvent', 'POST'),
            'getCouponDetail': S('getCouponDetail', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.couponDetail', 'POST'),
            'getEventTriggerDetail': S('getEventTriggerDetail', '/cmd=com.xqxc.api.pig.mis.biz.platform.marketing.EventTriggerMisService.getEventTriggerDetail', 'POST'),
        },
        reducers: {
            'EventTriggerByPage': R('getEventTriggerByPage', dataList),
            'EventTouchEnum': R('getEventTouchEnum', []),
            'PeriodTypeEnum': R('getPeriodTypeEnum', []),
            'OwnerEnum': R('getOwnerEnum', []),
            'ProvideTypeEnum': R('getProvideTypeEnum', []),
            'RewardTypeEnum': R('getRewardTypeEnum', []),
            'TrigEventTypeEnum': R('getTrigEventTypeEnum', []),
            'TriggerTypeEnum': R('getTriggerTypeEnum', []),
            'listCoupon': R('getlistCoupon', dataList),
            'CouponDetail': R('getCouponDetail', {}),
            'EventTriggerDetail': R('getEventTriggerDetail', {}),
        }
    })
};
export default createModel(model);